// 导入组件
import dragSet from './src/dragSet.vue'

// 为组件提供 install 安装方法，供按需引入
dragSet.install = function (Vue) {
  Vue.component(dragSet.name, dragSet)
}

// 默认导出组件
export default dragSet
